// ==================================================================
// 絞り込み条件削除
// ==================================================================
function clearNarrowing(formid){
  setColor(formid, '');
  setPrice(formid, false);
  submitForm(formid);
}

// ==================================================================
// 価格絞り込み
// ==================================================================
function setPrice(formid, isNarrow){
  if(isNarrow){
    var price1_val = $("#price1_val").val();
		var price2_val = $("#price2_val").val();
		price1_val_orig = price1_val.split(",").join("");
		price2_val_orig = price2_val.split(",").join("");
		$("#"+formid+" input[name='filter.v.price.gte']").val(price1_val_orig);
		$("#"+formid+" input[name='filter.v.price.lte']").val(price2_val_orig);
		$("#"+formid+" #price1_val").val(price1_val_orig);
		$("#"+formid+" #price2_val").val(price2_val_orig);
  } else {
    $("#"+formid+" #price1_val, input[name='filter.v.price.gte']").val('');
    $("#"+formid+" #price2_val, input[name='filter.v.price.lte']").val('');
  }
}
function submitPrice(formid, isNarrow){
  setPrice(formid, isNarrow);
  submitForm(formid);
}
function setPriceForm(inputid){
  var num = String($("#"+inputid).val());
  numtemp = num.replace(/[^0-9]/g,'');
  if(numtemp > 10000000){numtemp = 10000000;}
  var separated_num = separate(numtemp);
  $("#"+inputid).val(separated_num);
}
function setSPPrice(formid, isNarrow){
  if(isNarrow){
    var val1 = $("select#price1_val_sp option:selected").val();
    var val2 = $("select#price2_val_sp option:selected").val();
		val1_val_orig = val1.split(",").join("");
		val2_val_orig = val2.split(",").join("");
    $("#"+formid+" input[name='filter.v.price.gte']").val(val1_val_orig);
    $("#"+formid+" input[name='filter.v.price.lte']").val(val2_val_orig);
  } else {
    $("select#price1_val_sp").val('');
    $("select#price2_val_sp").val('');
    $("#"+formid+" input[name='filter.v.price.gte']").val('');
    $("#"+formid+" input[name='filter.v.price.lte']").val('');
  }
}

// ==================================================================
// カラー絞り込み
// ==================================================================
function setColor(formid, colorid){
  $('.detail-search .color-search li').each(function(index, el) {
    $(this).removeClass('on');
  });
  if(colorid){
    $('.detail-search .color-search li.colortip'+colorid).addClass('on');
  }
  $("#"+formid+" input[name='color_category_id']").val(colorid);
}
function submitColor(formid, colorid){
  $("#"+formid+" input[name='filter.v.price.gte']").val('');
  $("#"+formid+" input[name='filter.v.price.lte']").val('');
  setColor(formid, colorid);
  submitForm(formid);
}

// ==================================================================
// 並び順変更
// ==================================================================
function setOrder(formid, setval){
  if(setval!=''){
    $("#"+formid+" input[name='sort_by']").val(setval);
  } else{
    $("#"+formid+" input[name='sort_by']").val('');
  }
}
function submitOrder(formid, setval){
  setOrder(formid, setval);
  submitForm(formid);
}
function submitSelectOrder(formid){
  var setval = $("select#SortBy option:selected").val();
  submitOrder(formid, setval);
}

// ==================================================================
// ステータス
// ==================================================================
function setStatus(formid, setval){
  var default_val = $("#"+formid+" input[name='filter.p.tag']").val();
  if(setval!=''){
    if(default_val != '') {
      setval = default_val+','+setval;
    }
    $("#"+formid+" input[name='filter.p.tag']").val(setval);
  } else {
    $("#"+formid+" input[name='filter.p.tag']").val(default_val);
  }
}
function submitStatus(formid, setval){
  setStatus(formid, setval);
  submitForm(formid);
}
function setSelectStatus(formid){
  var setval = $("select#item-select-status option:selected").val();
  setStatus(formid, setval);
}

// ==================================================================
// カラバリ表示
// ==================================================================
function setColorVar(formid, setval){
  $("#"+formid+" input[name='filter.v.m.custom._primary_color']").val(setval);
}
function submitColorVar(formid, setval){
  setColorVar(formid, setval);
  submitForm(formid);
}
function setSelectColorVar(formid){
  var setval = $("select#item-select-colorvar option:selected").val();
  setColorVar(formid, setval);
}

// ==================================================================
// カテゴリ
// ==================================================================
function setCategory(formid){
  var cate_id = $("select#item-select-category option:selected").data("category");
  var sub_id = $("select#item-select-category option:selected").val();
  $("#"+formid+" input[name='category_id").val(cate_id);
  $("#"+formid+" input[name='sub_category_id").val(sub_id);
}
